import React, {useState, useEffect} from 'react';
import {FormControl,InputLabel,Select as MaterialSelect ,
  Box,Typography} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
//import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
//import Alert from '@material-ui/lab/Alert';
import {DateTimePicker, MuiPickersUtilsProvider, TimePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";
import ModalTam from '../Generales/ModalTam';
import {toast} from 'react-toastify';
import {llamadaApiToken,llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'noWrap',
    //alignItems: 'center',
    flexDirection:"column"
  },
  wrapper: {
    //margin: theme.spacing(0),
    margiTop: 0,
    paddingTop:0,
    position: 'relative',
  },
 
  buttonGuardar:{color: green[500],},
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function ModalNvoBitacora({modalAbierto,setModalAbierto,titulo,listStatus ,listTipo,actualizar, auxOrden}) {  
  let history = useHistory();
  const classes = useStyles();
  const idusu= localStorage.getItem('UsuId');
  const source = axios.CancelToken.source();   
  const [aviso, setAviso] = useState(false);  
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');    
  const [registro,setRegistro]= useState({ Usuario:'', Terminal:'', Descripcion:'', registro:0,
                                              Ubicacion:'', TipoId:'', Status:"", Titulo:"", Maquinaria:"",
                                              refaccion:"", direccion:"", auxId:0})          
  
  const [espera,setEspera]=useState(false);
  const [banderaFch, setBanderaFch]=useState(false);
  const [fechas,setFechas]=useState({inicio:new Date() ,final:new Date()});
  const [listMaquinaria, setListMaquinaria]=useState([]);
  const [listRefaccion, setListRefaccion]=useState([]);
  const {Descripcion, Maquinaria, Ubicacion, auxId, TipoId, Status, Titulo, refaccion, direccion} = registro;
  const {inicio,final}=fechas  

  useEffect(()=>{
 
    console.log(listStatus);
    
      setRegistro({...registro, auxId: auxOrden.Id,   })
  
    return () => {
      source.cancel();
    }

  },[])

  const guardarInicio = auxfecha =>
  {
    setFechas({...fechas, inicio: auxfecha })
  };

  const guardarFinal = auxfecha => {
    setBanderaFch(true)
    setFechas({...fechas, final: auxfecha})
  };


  const registrarNvo=()=>{
    const fini=moment(inicio).format("YYYY-MM-DDTHH:mm:ss")      
  
    const data = qs.stringify({                    
        Usuario:idusu,
        Llave:auxId,                     
        Status:Status,                              
        Nota:Descripcion,
        idDispositivo:'iu87ygubhjjij',
    });   
    const url = "/renta/bitacora/new";
    function respuesta(aux) {
      if (aux.respuesta === 1) 
      {   let mensaje="Se registro correctamente "
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)           
        //setRegistroExitoso(true) 
        toast.success(mensaje,{
          pauseOnFocusLoss: false,                    
          toastId: `nvo-cctv${aux.mensaje}`
        })
        actualizar()
        setModalAbierto(false)
      }       
    }    
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source); 
  }  

  const mostrarAlertas =(auxMensaje)=>{ 
    setTipoAdvertencia("warning")
    let mensaje=auxMensaje            
    setMensaje(mensaje);
    setAviso(true)   
  } 

  function valNulos(auxMensaje,auxCampo) 
  {    let valida=false    
    if ( auxCampo !== '' && auxCampo !== '0' && auxCampo !==0 
        && auxCampo !== null && auxCampo!==" " ) 
    {   valida=true              
    }
    if (!valida) 
    {   mostrarAlertas(auxMensaje)
    }
    return valida
  }

  function valBool(auxMensaje,auxCampo) 
  {    let valida=false    
    if ( auxCampo ) 
    {   valida=true              
    }
    if (!valida) 
    {   mostrarAlertas(auxMensaje)
    }
    return valida
  }
 

  const guardarParo = () => {
  
    if ( valNulos("Seleccionar Estatus",Status )   ) 
    {         
      setAviso(false)                                                                                       
      registrarNvo()                                     
    }                           
  };
  
  const onChange = e =>
  {
    setRegistro({ ...registro, [e.target.name] : e.target.value })
  };

  const fecha=() =>{
  return  <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>      
 
    <DateTimePicker disableFuture
      label="Fecha Evento" size={"small"}  
      value={inicio} style={{width:10+'rem', marginRight:"1rem"}}
      onChange={guardarInicio}
      //views={["year", "month", "date"]}  
      minDate="2017-03-14" maxDate={new Date()}
      format="dd/MM/yyyy HH:mm"
      cancelLabel={"Cancelar"} okLabel="Seleccionar"       
    />
                  
  </MuiPickersUtilsProvider>
  }
  
  return (
    <ModalTam  titulo={titulo} modalAbierto={modalAbierto} 
      setModalAbierto={setModalAbierto} guardarDatos={guardarParo} 
      mensaje={mensaje} tipoAdvertencia={tipoAdvertencia} 
      aviso={aviso} setAviso={setAviso} espera={espera} 
      setEspera={setEspera} tamanio="md" btnDesact={false}
    >    
    <form className={classes.root} noValidate autoComplete="off" fullWidth>     
   
    <Box mb={2} display={"flex"} >
    
    { listStatus.length !== 0 ?
      <FormControl className={classes.formControl} size="small"  style={{marginTop:".5rem", marginRight:"1rem"}} >
        <InputLabel htmlFor="age-native-simple">Estatus</InputLabel>
        <MaterialSelect
          native value={Status} onChange={onChange}
          inputProps={{ name: 'Status', id: 'Status',}}
        >
          <option aria-label="None" value="" />                     
          {listStatus.map((row,index) => {
            if (row.value===2 || row.value===1) {
             return <option value={row.value} key={index} >{row.label}</option> 
            }
          })}   
        </MaterialSelect>
      </FormControl>     
    :null }       
    { /* listTipo.length !== 0 ?
      <FormControl className={classes.formControl} size="small" style={{marginLeft:1+'rem'}} >
        <InputLabel htmlFor="age-native-simple">Tipo</InputLabel>
        <MaterialSelect
          native value={TipoId} onChange={onChange}
          inputProps={{ name: 'TipoId', id: 'TipoId',}}
        >
          <option aria-label="None" value="" />                     
          {listTipo.map((row,index) => (
            <option value={row.value} key={index} >{row.label}</option>
          ))}   
        </MaterialSelect>
      </FormControl>     
    :null  */ }   
    <Box style={{marginTop:".5rem" }}>
      {fecha()}
    </Box>    
            
    </Box>                          
{/*     <Box>
      <Typography component="p" variant="body2" color='primary' 
        style={{margin:0,marginLeft:.5+'rem'}} 
      >
        Titulo
      </Typography>   
      <textarea id="Titulo-input" name="Titulo" rows="3" placeholder="Titulo"
        cols="100" style={{width: 24+"rem",borderRadius:3+'px'}} 
        value={Titulo} onChange={onChange} maxlength={500}
      />
    </Box> */}
  
    <Box>
      <Typography component="p" variant="body2" color='primary' 
        style={{margin:0,marginLeft:.5+'rem'}} >
          Notas
      </Typography>   
      <textarea id="descripcion-input" name="Descripcion" rows="5"
        cols="100" placeholder="Notas" style={{width: 24+"rem",borderRadius:3+'px'}} 
        value={Descripcion} onChange={onChange} maxlength={500}
      />
    </Box>
  </form>
  </ModalTam>
  );
}
